<template lang="pug">
b-row.m-0(style="margin-top: 10px !important; width: 100%")
  b-col.pr-0.d-none.d-md-flex(md="4")
    .d-flex.flex-column.justify-content-start.h-100.pay-card
      h5.mb-2.title-st {{ $t('offer.payment.note') }}
      p.mt-1(style="font-size: 12px; padding-left: 5px; color: #33333385") {{ '* ' + $t('offer.payment.contactPayment') }}
  b-col.pl-0(md="8")
    vv-observer(tag="div" v-slot="{ invalid }" ref="observer")
      .d-flex.flex-column.justify-content-start.h-100.pay-card
        h5.mb-2.title-st {{ $t('offer.payment.title') }}
        b-row.m-0
          b-col.p-0.pr-1.mb-2(sm="6")
            .pay-methode-container.d-flex.justify-content-center.align-items-center(@click="initPayement('card')" :class="{ 'pay-methode-container-selected' : selectedOption=='card'}" )
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18" height="18" viewBox="0 0 24 24"> <path class="pay-ico-path" d="M4 4C2.895 4 2 4.895 2 6L2 18C2 19.105 2.895 20 4 20L15 20L15 19L15 18L15 17L13 17L13 15L15 15C15 14 16 14 16 14L16.349609 14C17.066609 11.975 18.835 10.365 21 10L22 10L22 6C22 4.895 21.105 4 20 4L4 4 z M 5 7L8 7L8 10L5 10L5 7 z M 13 8L19 8L19 10L13 10L13 8 z M 22.119141 12C18.464141 12.001 18.053812 15.149156 18.007812 15.910156L18.007812 16L17 16L17 17L18.005859 17L18.003906 18L17 18L17 19L18 19L18 19.068359C17.999 20.621359 18.838984 23 21.958984 23C22.761984 22.999 23.456375 22.854156 23.734375 22.785156L23.445312 20.990234C23.258312 21.068234 22.830219 21.21875 22.199219 21.21875C20.355219 21.21875 19.995375 19.475359 19.984375 19.068359L19.984375 19L22 19L22 18L19.990234 18L19.994141 17L22 17L22 16L20 16L20 15.910156C20.048 15.164156 20.646094 13.796875 22.246094 13.796875C22.773094 13.796875 23.271359 13.964203 23.443359 14.033203L23.734375 12.228516C23.465375 12.158516 22.789141 12 22.119141 12 z M 5 15L7 15L7 17L5 17L5 15 z M 9 15L11 15L11 17L9 17L9 15 z" fill="#a43246" /> </svg>
              .ml-2 {{ $t('offer.payment.byCard') }}
          b-col.p-0.mb-2(sm="6")
            .pay-methode-container.d-flex.justify-content-center.align-items-center(@click="initPayement('sepa_debit')" :class="{ 'pay-methode-container-selected' : selectedOption=='sepa_debit'}")
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18" height="18" viewBox="0 0 24 24"> <path class="pay-ico-path" d="M12 2.5L3 6.5L3 9L5 9L5 17L7 17L7 9L9 9L9 17L11 17L11 9L13 9L13 17L15 17L15 9L17 9L17 17L19 17L19 9L21 9L21 6.5L12 2.5 z M 3 19L3 21L21 21L21 19L3 19 z" fill="#a43246" /> </svg>
              .ml-2 {{ $t('offer.payment.byBA') }}
        
        b-row.m-0(v-if="selectedOption && selectedOption=='sepa_debit'")
          b-col.p-0.pr-1.mb-2(sm="6")
            r-input.pay-input-data.m-0(:placeholder="$t('form.email')" v-model="userEmail" name="email" type="email")
          b-col.p-0.pl-1.mb-2(sm="6")
            r-input.pay-input-data.m-0(:placeholder="$t('form.fullname')" v-model="userName" name="fullname")
        .mb-2.card-st(v-if="selectedOption")
          div(ref="card" v-if="selectedOption")
        div(v-if="selectedOption")
          b-button(block, :disabled="btnPaymentDisabled || (selectedOption=='sepa_debit' && invalid)", @click="pay" ) {{ $t('offer.payment.cta.submit') }}
          //- .text-center
          //-   .text-secondary.clickable.underline.mt-3(href="#" @click.prevent="refuseOffer") {{ $t('offer.payment.cta.refuse') }}
          //-   .text-muted
          //-     small {{ $t('offer.payment.cta.disclaimer') }}
        p.mt-1.d-flex.d-md-none(style="font-size: 12px; padding-left: 5px; color: #33333385") {{ '* ' + $t('offer.payment.contactPayment') }}
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import { mapState } from "vuex";
import { Auth } from 'aws-amplify'

export default {
  name: "OfferPending",
  props: {
    reply: {
      type: Object,
      default: () => {},
    },
    id: {
      type: String,
      default: "001",
    },
  },
  data() {
    return {
      clientSecret: null,
      card: null,
      elements: null,
      btnPaymentDisabled: true,
      loaded: false,
      options : {
        style: {},
        supportedCountries: ["SEPA"]
      },
      selectedOption : null,
      userEmail : null,
      userName : null
    };
  },
  async mounted() {
  },
  methods: {
    async initPayement(type){
      this.userEmail = this.email;
      this.userName = this.fullName;
      this.selectedOption = type;
      this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
      this.elements = this.stripe.elements();
      this.card = type=='card' ? this.elements.create('card',{hidePostalCode: true}) : this.elements.create('iban',this.options);
      this.card.mount(this.$refs.card);
      this.card.on("change", (event) => {
        // Disable the Pay button if there are no card details in the Element
        this.btnPaymentDisabled = !event.complete ;
      });
      // sepa_debit
      this.requestPaymentIntent(type).then((data) => {
        this.clientSecret = data.clientSecret;
        this.loaded = true;
      });
    },
    async requestPaymentIntent(type) {
      // Utilise raply id au lieu de transit id
      return await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/transit/${this.reply.replyId}/client/payement/${type}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          },
          method: "POST",
        }
      ).then((response) => response.json());
    },
    async refuseOffer() {
      await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/transit/${this.transitId}/reply/${this.replyId}/decline`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          },
          method: "POST",
        }
      ).then(() => {
        this.$notify({
          type: "warn",
          group: "default",
          title: this.$t("notifications.transit.offerDeclined.title"),
        });
        this.$store.dispatch("fetchClientTransit");
      });
    },
    pay() {
      if(!this.btnPaymentDisabled){
        if(this.selectedOption=='card'){
          this.btnPaymentDisabled=true;
          this.stripe
          .confirmCardPayment(this.clientSecret, {
            payment_method : { card : this.card }
          })
          .then((result) => {
            if (result.error) {
              console.log(result.error);
              // Show error to your customer
              this.$notify({
                type: "danger",
                group: "default",
                title: this.$t("notifications.transit.payment.titleError"),
                text: result.error.message,
              });
              this.btnPaymentDisabled=false;
            } else {
              // The payment succeeded!
              this.$notify({
                type: "success",
                group: "default",
                title: this.$t("notifications.transit.payment.titleSuccess"),
                text: this.$t("notifications.transit.payment.msgSuccess"),
              });
              setTimeout(() => {  
                this.$router.replace({ name: "clientDashboard", params: { }, query: {id : this.transitId} })
              }, 5000);
              
            }
          });
        } else{
          this.btnPaymentDisabled=true;
          this.stripe
          .confirmSepaDebitPayment(this.clientSecret, {
            payment_method : { 
              sepa_debit : this.card,
              billing_details : {
                name : this.userName,
                email : this.userEmail
              }
            }
          })
          .then((result) => {
            if (result.error) {
              console.log(result.error);
              // Show error to your customer
              this.$notify({
                type: "danger",
                group: "default",
                title: this.$t("notifications.transit.payment.titleError"),
                text: result.error.message,
              });
              this.btnPaymentDisabled=false;
            } else {
              // The payment succeeded!
              this.$notify({
                type: "success",
                group: "default",
                title: this.$t("notifications.transit.payment.titleSuccess"),
                text: this.$t("notifications.transit.payment.msgSuccess"),
              });
              setTimeout(() => {  
                this.$router.replace({ name: "clientDashboard", params: { }, query: {id : this.transitId} })
              }, 5000);
              
            }
          });
        }
        }
    },
  },
  computed: {
    ...mapState(["currentUser"]),
    replyId() {
      return this.reply.replyId;
    },
    transitId() {
      return this.reply.transitId;
    },
    fullName() {
      return this.currentUser.user.attributes.family_name.charAt(0).toUpperCase() + this.currentUser.user.attributes.family_name.slice(1).toLowerCase() + ' ' + this.currentUser.user.attributes.name.charAt(0).toUpperCase() + this.currentUser.user.attributes.name.slice(1).toLowerCase();
    },
    email(){
      return this.currentUser.user.attributes.email;
    }
  },
};
</script>

<style>
.offer-div {
  border: 2px solid #3333330d;
  background-color: #d3d4d414;
  border-radius: 5px;
  padding: 12px 5px;
  width: 100%;
  margin-bottom: 10px;
}
.offer-div:last-child {
  margin-bottom: unset;
}
.offer-div-t {
  font-size: 2em;
  font-weight: 700;
  color: #a43246;
}
.price-div-t {
  font-size: 1.5em;
  font-weight: 700;
  color: #a43246;
}
.offer-details {
  /* border: 1px solid #a4324612; */
  padding: 5px 10px 10px 10px;
  border-radius: 7px;
  background-color: #a4324603;
}
.pay-card {
  padding: 8px;
  border-radius: 5px;
  min-height: 150px;
  /* border: 1px solid #a4324626; */
}
.title-st {
  color: #a43246;
  font-size: 16px;
  background-color: #f7f2f3;
  padding: 7px 10px;
  border-radius: 5px;
}
.card-st {
  background-color: #ebebeb0d;
  padding: 10px 6px;
  border-radius: 5px;
  border: 1px solid #4c4c4c17;
}
.card-st-loading {
  height: 39px;
  border: unset;
}
.pay-methode-container{
  padding: 10px;
  background-color: #f7f2f3;
  font-size: 13px;
  font-weight: 600;
  color: #a43246;
  border: 1px solid #a4324647;
  border-radius: 5px;
}
.pay-methode-container:hover, .pay-methode-container-selected{
  color: white;
  background-color: #a43246;
  transition: all 0.2s;
  cursor: pointer;
}
.pay-methode-container:hover .pay-ico-path, .pay-methode-container-selected .pay-ico-path{
  fill: white !important;
}
.pay-input-data .text-danger {
  color: #EC432F !important;
  margin-left: 5px;
}
.pay-input-data .form-control.is-invalid {
  border-color: #EC432F !important;
}
.pay-input-data .form-control{
  padding: 19px 10px !important;
  background-color: #ebebeb0d;
  border-radius: 5px;
  border: 1px solid #4c4c4c17;
  color: black;
}
</style>